import { Navbar, Footer } from '@/components/marketing';
import { Shield, Lock, Eye, Server, CheckCircle } from 'lucide-react';

const securityFeatures = [
  {
    icon: Lock,
    title: 'End-to-End Encryption',
    description: 'All data is encrypted in transit and at rest using industry-standard AES-256 encryption.',
  },
  {
    icon: Shield,
    title: 'SOC 2 Type II Compliant',
    description: 'Our infrastructure and processes are audited annually to ensure security best practices.',
  },
  {
    icon: Eye,
    title: 'Privacy First',
    description: 'We never sell your data. Your business information stays yours, always.',
  },
  {
    icon: Server,
    title: 'Secure Infrastructure',
    description: 'Hosted on enterprise-grade cloud infrastructure with 99.9% uptime SLA.',
  },
];

export default function SecurityPage() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <section className="pt-32 pb-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">
              Security at SparkCommerce
            </h1>
            <p className="text-lg text-muted-foreground">
              Your data security is our top priority. We implement industry-leading 
              security measures to protect your business.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {securityFeatures.map((feature) => {
              const Icon = feature.icon;
              return (
                <div
                  key={feature.title}
                  className="p-6 rounded-2xl bg-card border border-border"
                >
                  <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                  <p className="text-muted-foreground">{feature.description}</p>
                </div>
              );
            })}
          </div>

          <div className="mt-16 max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold mb-6 text-center">Our Security Practices</h2>
            <div className="space-y-4">
              {[
                'Regular security audits and penetration testing',
                'Multi-factor authentication for all accounts',
                'Role-based access control',
                'Automated threat detection and response',
                'Regular data backups with disaster recovery',
                'Compliance with GDPR and data protection regulations',
              ].map((practice) => (
                <div key={practice} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-green-500 shrink-0" />
                  <span>{practice}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
